<template>
  <div>
    <!-- 订单管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:20px">
      <div class="titleStyle">
        <el-input placeholder="手机号" clearable v-model="data.Mobile"></el-input>
        <el-input placeholder="订单号" clearable v-model="data.OrderNumber"></el-input>
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>

        <el-select v-model="data.ScenicID"  filterable placeholder="全部景区" clearable>
          <el-option
              v-for="item in options"
              :key="item.ScenicID"
              :label="item.Name"
              :value="item.ScenicID"
            ></el-option>
        </el-select>
        <el-select v-model="data.distributortwo_id" filterable placeholder="请选择二级分销商" clearable>
          <el-option
            v-for="item in distribution"
            :key="item.DistributorID"
            :label="item.Name"
            :value="item.DistributorID"
          ></el-option>
        </el-select>
        <el-select v-model="data.status" placeholder="验票查询" clearable>
          <el-option
            v-for="item in yanArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button @click="inquire">查询</el-button>
        <el-button class="btnL" @click="exportExcel">导出报表</el-button>
      </div>
      <div>
        <el-table
          :data="list"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
          id="vcfResult"
        >
          <!-- <el-table-column label="序号" type="index"></el-table-column> -->
          <el-table-column prop="scenic_name" label="景区名称">
          </el-table-column>
          <el-table-column prop="CreateTime" label="下单时间"></el-table-column>
          <el-table-column prop="OrderNumber" label="订单号"></el-table-column>
          <el-table-column prop="OnlyCode" label="第三方订单号"></el-table-column>
          <el-table-column prop="OrderCode" label="消费码"></el-table-column>
          <el-table-column label="订单内容" width="400">
            <template slot-scope="scope">
                <div class="orderContent" v-for="(item,index) in scope.row.order_detail" :key="index">
                  <span  style="cursor: pointer;" @click="proInfoFn(item)">{{item.OrderAll.productname}}</span>
                  <span v-if="item.OrderAll.type==1">游玩时间：{{item.playdate}}</span>
                  <span v-if="item.OrderAll.type==0">游玩时间：{{item.OrderAll.consumebegindate}}--{{item.OrderAll.consumeenddate}}</span>
                  <span>游客名称：{{scope.row.consumer}}  联系电话：{{scope.row.Mobile}}</span>
                  <span v-if="scope.row.idcard!=''">身份证：{{scope.row.idcard}}</span>
                </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="状态">
            <template slot-scope="scope">
                {{ scope.row.type=='0'?'未验票':scope.row.type=='1'?'验票':'退票' }}
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="OrderCode" label="消费码"></el-table-column>
          <el-table-column prop="Mobile" label="接收号码"></el-table-column> -->
          <el-table-column prop="ActFee" label="订单总额"></el-table-column>
          <el-table-column  label="可退数量">
            <template slot-scope="scope">
             <span>{{ scope.row.nums }}</span>
            </template>
          </el-table-column>
          <el-table-column  label="退票数量">
            <template slot-scope="scope">
              <el-input 
                v-model.number="scope.row.types" 
                type="number"
                :min="0"
                @input="handleTypesInput(scope.row)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column  label="操作" width="240"    fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="infoTp(scope.row)">退票</el-button>
              <el-button type="text" @click="infoFn(scope.row)">查看详情</el-button>
              <el-button type="text" @click="seeShopFn(scope.row)">二维码</el-button>
              <el-button type="text" @click="repeat(scope.row)">重发短信</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页开始 -->
        <div class="pagination">
          <span class="demonstration">共{{total}}条记录，</span>
          <span class="demonstration">当前显示第{{data.page}}页</span>
          <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page.sync="data.page"  @current-change="currenchange"></el-pagination>
        </div>
        <!-- 分页结束 -->
      </div>
    </el-card>
    
    <!-- 产品详情开始 -->
    <orderMangDialog v-if="infovisible" ref="infoDialog" :order_id="order_id" @CloseGb="MangDialogClose"></orderMangDialog>
    <!-- 产品详情结束 -->
    <!-- 订单列表开始 -->
    <!-- <orderListDialog v-if="ordervisible" ref="orderDialog"></orderListDialog> -->
    <!-- 订单列表结束 -->
     <!-- 二维码 -->
     <div class="fixed" v-if="fixedFlag">
        <div class="fixed_box">
            <div class="fixed_box_tit">
              <span>二维码</span>
              <img src="@/images/distributor/Grou.png" alt="" @click="closeFlag">
            </div>
            <div class="fixed_box_content">
                <img :src="img" alt="">
            </div>
        </div>
     </div>
     <proInfoDialog v-if="proInfovisible" ref="proInfoDialog" :productId="productId" @close="closeProduct"></proInfoDialog>
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import orderMangDialog from "./dialog/orderMangDialog.vue";
import proInfoDialog from "../product/dialog/proInfoDialog.vue";
// import orderListDialog from "./dialog/orderListDialog.vue";
import {getDistributorOrderList,
  getDistrbutorScenicList,
  getImpowerDistrbutorTwoList,
  sendSms,
  distributorRefund,
  distributorPostExport} from '@/request/distributor.js'
export default {
  components: {
    orderMangDialog,
    proInfoDialog
    // orderListDialog
  },
  data() {
    return {

      productId:'',
      proInfovisible:false,
      shopListVisible: false, // 产品列表
      infovisible: false, // 产品详情
      ordervisible: false, // 订单列表
      options: [
      ],
      erjiArr:[],
      yanArr:[
        {
          value:'0',
          label:'未验票'
        },
        {
          value:'1',
          label:'验票'
        },
        {
          value:'2',
          label:'退票'
        }
      ],
      value: "",
      value1: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        Mobile:'',
        OrderNumber:"",
        start_time:"",
        end_time:"",
        distributortwo_id:"",
        status:"",
        page:1,
        page_size:8,
        ScenicID:""
      },
      list:[],
      distribution:[
        {
          DistrbutorID:"a",
          Name:'景区直销'
        }
      ],
      order_id:"",
      total:0,
      fixedFlag:false,
      img:""
    };
  },
  created(){
    this.getList()
    this.sceniclist()
    this.impower()
  },
  methods: {
       // 产品详情
    proInfoFn(row) {
      console.log(row)
      this.productId = row.OrderAll.productid
      this.proInfovisible = true;
      this.$nextTick(() => {
        this.$refs.proInfoDialog.proInfo();
      });
    },
       // 关闭详情
    closeProduct(){
      this.proInfovisible = false
    },
    handleTypesInput(row) {
      // 确保输入值不能为负数
      if (row.types < 0 || row.types === null || row.types === undefined) {
        row.types = 0;
      }
      // 如果是字符串，转换为数字
      if (typeof row.types === 'string') {
        const num = parseFloat(row.types);
        if (isNaN(num) || num < 0) {
          row.types = 0;
        } else {
          row.types = num;
        }
      }
      this.onInput();
    },
    onInput(){
      this.$forceUpdate();
    },
    // 退票
    infoTp(row){
      var orderdetailid = ''
      row.order_detail.map(item=>{
        orderdetailid += item.OrderDetailID + ','
      })
      if (orderdetailid.length > 0) {
        orderdetailid = orderdetailid.substr(0, orderdetailid.length - 1);
      }
      if(row.types==0){
        this.$message.error('请输入退票数量')
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ordernumber:row.OrderNumber,
        orderdetailid:orderdetailid,
        ordernum:row.types
      }
      distributorRefund(data).then(res=>{
        if(res.data.status=='ok'){
         this.getList()
          this.$message.success('退票成功')
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // 导出
    exportExcel(){
      if(this.value1){
        this.data.start_time = this.value1[0]  + ' 00:00:00'
        this.data.end_time = this.value1[1] + ' 23:59:59'
      }else{
        this.data.start_time = ''
        this.data.end_time =''
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        Mobile:this.data.Mobile,
        OrderNumber:this.data.OrderNumber,
        start_time:this.data.start_time,
        end_time:  this.data.end_time,
        distributortwo_id:this.data.distributortwo_id,
        status:this.data.status,
        ScenicID:this.data.ScenicID 
      }
      distributorPostExport(data).then(res=>{
        if(res.data.status=='ok'){
            const newUrl = res.data.result;
            const a = document.createElement("a");
            a.href = newUrl;
            a.download = '导出列表';
            a.target = "_blank";
            a.click();
        }
      })
    },
    // 查询
    inquire(){
      this.data.page = 1
      if(this.value1){
        this.data.start_time = this.value1[0]  + ' 00:00:00'
        this.data.end_time = this.value1[1] + ' 23:59:59'
      }else{
        this.data.start_time = ''
        this.data.end_time =''
      }
      this.getList()
    },
    // 订单列表
    getList(){
      getDistributorOrderList(this.data).then(res=>{
        if(res.data.status=='ok'){
          res.data.result.data.map(item=>{
            item.types = 0
            if(item.order_detail[0].OrderAll.producttype==20){
              if(item.UseCount>0){
                item.UseCount = item.Count
              }
              item.nums = item.Count - item.UseCount - item.CancleCount
            }else{
              item.nums = item.Count - item.UseCount - item.CancleCount
            }
          })
          this.list = res.data.result.data
          this.total = Number(res.data.result.total)
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    // 分页
    currenchange(e){
      this.data.page = e
      this.getList()
    },
    // 景区
    sceniclist(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:999
      }
      getDistrbutorScenicList(data).then(res=>{
        if(res.data.status=='ok'){
          this.options = res.data.result.data
        }
      })
    },
    // 二级分销商列表
    impower(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:999
      }
      getImpowerDistrbutorTwoList(data).then(res=>{
          if(res.data.status=='ok'){
            // this.distribution = res.data.result.data
            this.distribution = [...this.distribution,...res.data.result.data]
          }
      })
    },
    // 关闭详情
    MangDialogClose(){
      this.infovisible = false
    },
    // 重发短信
    repeat(row){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ordernumber:row.OrderNumber
      }
      sendSms(data).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('重发成功')
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    // 点击订单列表
    orderListFn(row) {
      this.ordervisible = true;
      this.$nextTick(() => {
        this.$refs.orderDialog.orderList(row);
      });
    },
    // 点击产品详情
    infoFn(row) {
      this.order_id = row.OrderID
      this.infovisible = true;
      this.$nextTick(() => {
        this.$refs.infoDialog.Info(row);
      });
    },
    // 点击查看产品弹出产品列表弹框
    seeShopFn(row) {
      this.img  = 'http://home.softykt.net/index/ifsm.html?code=' + row.OrderCode
      this.fixedFlag = true;
    },
    closeFlag(){
      this.fixedFlag = false
    },
    // 产品列表X
    shopListHandleClose() {
      this.shopListVisible = false;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.shopTitle {
  margin-bottom: 20px;
  .el-input {
    width: 240px;
    margin-right: 20px;
  }
  .el-select {
    width: 260px;
    margin-right: 20px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
}
.titleStyle {
  margin-bottom: 20px;
  .el-input {
    width: 220px;
    height: 40px;
    margin-right: 20px;
    margin-bottom: 1rem;
  }
  .el-select {
    margin-bottom: 1rem;
    width: 220px;
    margin-right: 20px;
  }
  .el-date-editor {
    // width: 250px;
    margin-bottom: 1rem;
    margin-right: 20px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-right: 10px;
  }
  .btnL {
    width: 120px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #246deb;

  }
}
/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.fixed{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fixed_box{
  background: #fff;
  width: 42.5rem;
  padding: 2.4rem 0;
}
.fixed_box_tit{
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom:1px solid #E5E5EA ;
  padding-bottom: 1.8rem;
  position: relative;
}
.fixed_box_tit span{
  color: #000000;
  font-size:2rem;
  font-weight: 600;
}
.fixed_box_tit img{
  width: 2.4rem;
  height: 2.4rem;
  position: absolute;
  right: 2rem;
  cursor: pointer;
}
.fixed_box_content{
  padding: 4rem;
  box-sizing: border-box;
}
.fixed_box_content img{
  width: 34.5rem;
  height: 34.5rem;
}
.titleStyle /deep/ .el-button{
  margin-top: 15px;
  background: #246deb;
  color: #fff;
}

.orderContent{
  display: flex;
  flex-direction: column;
}
.orderContent span{
  text-align: left;
  color: #000000;
  font-size: 1.4rem;
  margin-bottom: 2px;
  &:nth-child(1){
    color: #468BC8;
  }
}
</style>